import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { shareInfo } from '@dc-platform/dc-interaction'
import CosSingleDateTimePicker from '@/components/CosSingleDateTimePicker/index.vue'
import type { FormInstance } from 'ant-design-vue'
import { ref, computed, onMounted, watch } from 'vue'
import UploadFile from '@/components/UploadFile'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { fetchUsersByWorkCode, listByParamCodes } from '@/api/common'
import ClueAndCustomerSelect from '@/components/ClueAndCustomerSelect/index.vue'

import {
  salesSkillsCoachingCreate,
  salesSkillsCoachingDetail,
  salesSkillsCoachingUpdate,
  salesSkillsCoachingReview,
  salesSkillsCoachingConfirm
} from '@/api/yuntuSales/salesSkillsCoaching'

import { DcMessage, DcConfirm } from '@dc-platform/dc-components'
import { goBack } from '@/hooks/cosRouter'
import dayjs from 'dayjs'
import { useRouter, useRoute } from 'vue-router'

import { getFollowListByRefId } from '@/api/yuntuSales/superivisorAccompanyingVisit'

import { paramCodesDataFilter } from '@/utils'
import { followRecordsDetail } from '@/api/yuntuSales/followUpManage'


export default /*#__PURE__*/_defineComponent({
  __name: 'baseMessage',
  props: {
  value: Object,
  isEdit: {
    type: Boolean,
    required: true
  },
  view: {
    type: Boolean
  },
  type: {
    type: String,
    required: true,
    validator(value: string) {
      return ['add', 'edit', 'comment', 'review', 'view'].includes(value)
    }
  }
},
  emits: ['update:detail', 'getDetail'],
  setup(__props, { emit: __emit }) {

const router = useRouter()

const dataForm = ref<any>({})
const formRef = ref<FormInstance>()
const loading = ref(false)
const route = useRoute()
const props = __props

const handleCustomerNameChange = (value?: any) => {
  if (value === undefined) {
    followList.value = []
    selectedFollow.value = undefined
    dataForm.value.followId = undefined
  }
}

watch(
  () => dataForm.value.cosId,
  (val) => {
    if (val) {
      fetchFollowList()
    }
  },
  { immediate: true }
)

const followList = ref<any[]>([])
const selectedFollow = ref<any>({})

// 获取跟进记录列表
const fetchFollowList = async () => {
  getFollowListByRefId(dataForm.value.cosId).then((res) => {
    followList.value = res.data
  })
}

const changeFollow = (v: any) => {
  if (v) {
    selectedFollow.value = followList.value.find((item) => item.id === v)
    selectedFollow.value.followMode = paramCodeData.value.lbu_follow_mode.find(
      (item) => item.id === selectedFollow.value.mode
    )?.name
  } else {
    selectedFollow.value = {}
    dataForm.value.followId = undefined
  }
}

const paramCodeData = ref<{
  lbu_follow_mode: []
  lbu_follow_purpose: []
}>({
  lbu_follow_mode: [], // 拜访方式
  lbu_follow_purpose: [] // 访客目的
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: ['lbu_follow_mode', 'lbu_follow_purpose']
  }).then((res) => {
    if (res.code === 200) {
      if (props.view) {
        paramCodeData.value = {
          ...res.data
        }
      } else {
        // 递归过滤业务参数状态
        res.data = paramCodesDataFilter(res.data, 0)
        paramCodeData.value = {
          ...res.data
        }
      }
    }
  })
}

onMounted(() => {
  fetch()
  getByParamCodes()
})

const permissionPage = computed(() => {
  if (props.type === 'add') {
    return { save: 'lbu_sale_skills_coaching_add_btn' }
  } else if (props.type === 'edit') {
    return { save: 'lbu_sale_skills_coaching_edit_btn' }
  } else if (props.type === 'review') {
    return { save: 'lbu_sale_skills_coaching_review_btn' }
  } else {
    return {}
  }
})
const emit = __emit
const fetch = () => {
  if (route.query.id) {
    loading.value = true
    salesSkillsCoachingDetail({ id: route.query.id })
      .then((res) => {
        if (props.type === 'review') {
          if (!res.data.reviewTime) {
            res.data.reviewTime = dayjs().format('YYYY/MM/DD HH:mm:ss')
          }
        }

        dataForm.value = res.data ? res.data : {}
        fetchFollowList()
        if (dataForm.value.followId) {
          fetchFollowDetail(dataForm.value.followId)
        }
        emit('getDetail', res.data)
      })
      .finally(() => {
        loading.value = false
      })
  }
}

// 获取跟进记录详情
const fetchFollowDetail = async (id: any) => {
  followRecordsDetail(id).then((res) => {
    const followDetail = res.data
    if (followDetail) {
      selectedFollow.value = followDetail
      selectedFollow.value.followMode = paramCodeData.value.lbu_follow_mode.find(
        (item) => item.id === selectedFollow.value.mode
      )?.name
    }
  })
}

const handleMentorChange = (val: any) => {
  if (val && props.type === 'add') getFollowerInfo(val)
}

const handleTraineeChange = (val: any) => {
  if (val && props.type === 'add') {
    const employeeList = [val]
    fetchUsersByWorkCode({ employeeList }).then((res) => {
      const [followerInfo] = res.data
      if (followerInfo && followerInfo.lbuCustomerRegion != null) {
        dataForm.value.traineeRegion = followerInfo.lbuCustomerRegion
      } else {
        dataForm.value.traineeRegion = undefined
        setTimeout(() => formRef.value?.clearValidate('traineeRegion'))
      }
    })
  }
}

const handleFollowClick = () => {
  if (!props.view) {
    return
  }

  router.push({
    path: '/lbu/followUpRecord/view',
    query: {
      id: dataForm.value.followId
    }
  })
}

const getFollowerInfo = (workCode: string) => {
  const employeeList = [workCode]
  fetchUsersByWorkCode({ employeeList }).then((res) => {
    const [followerInfo] = res.data
    if (followerInfo && followerInfo.lbuCustomerRegion != null) {
      dataForm.value.mentorRegion = followerInfo.lbuCustomerRegion
    } else {
      dataForm.value.mentorRegion = undefined
      setTimeout(() => formRef.value?.clearValidate('mentorRegion'))
    }

    if (followerInfo && followerInfo.managerNo != null) {
      dataForm.value.ccTo = [`${followerInfo.managerNo}`]
    }
  })
}

const confirmRow = () => {
  DcConfirm.warning({
    title: '操作提示！',
    content: '是否确认此操作？',
    cancelText: '取消',
    okText: '继续',
    onOk() {
      salesSkillsCoachingConfirm({ id: route.query.id }).then(() => {
        DcMessage.success('操作成功')
        goBack()
      })
    }
  })
}

const reviewRow = () => {
  router.push({
    path: '/lbu/saleCoaching/review',
    query: {
      id: route.query.id
    }
  })
}

const commentRow = () => {
  router.push({
    path: '/lbu/saleCoaching/comment',
    query: {
      id: route.query.id
    }
  })
}

const editRow = () => {
  router.push({
    path: '/lbu/saleCoaching/edit',
    query: {
      id: route.query.id
    }
  })
}

const handleSubmit = async () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const p = {
      ...dataForm.value
    }
    try {
      if (props.type === 'edit') {
        await salesSkillsCoachingUpdate(p)
        DcMessage.success('编辑成功')
      } else if (props.type === 'add') {
        await salesSkillsCoachingCreate(p)
        DcMessage.success('新增成功')
      } else if (props.type === 'review') {
        await salesSkillsCoachingReview(p)
        DcMessage.success('回顾成功')
      }
      goBack()
    } catch (error) {}
    loading.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      ref_key: "formRef",
      ref: formRef,
      model: dataForm.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_card, {
          title: "基础信息",
          span: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: "辅导人",
              name: "mentor",
              rules: [{ required: true, message: '请输入' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_UserSelect, {
                  permission: "",
                  disabled: true,
                  value: dataForm.value.mentor,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.value.mentor) = $event)),
                  defaultValue: "me",
                  onChange: handleMentorChange,
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "辅导人区域" }, {
              default: _withCtx(() => [
                _createVNode(CustomerAreaCascader, {
                  appId: "cos_lbu",
                  value: dataForm.value.mentorRegion,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.value.mentorRegion) = $event)),
                  disabled: true,
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "本次辅导时间",
              rules: [{ required: true, message: '请选择' }]
            }, {
              default: _withCtx(() => [
                _createVNode(CosSingleDateTimePicker, {
                  startTime: dataForm.value.tutoringTime,
                  "onUpdate:startTime": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.value.tutoringTime) = $event)),
                  defaultValue: "now",
                  isRange: false,
                  view: __props.view
                }, null, 8, ["startTime", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "下次辅导时间",
              name: "nextTutoringTime",
              rules: [{ required: true, message: '请输入' }]
            }, {
              default: _withCtx(() => [
                _createVNode(CosSingleDateTimePicker, {
                  startTime: dataForm.value.nextTutoringTime,
                  "onUpdate:startTime": _cache[3] || (_cache[3] = ($event: any) => ((dataForm.value.nextTutoringTime) = $event)),
                  isRange: false,
                  view: __props.view
                }, null, 8, ["startTime", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "被辅导人",
              name: "trainee",
              rules: [{ required: true, message: '请输入' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_UserSelect, {
                  permission: "",
                  value: dataForm.value.trainee,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((dataForm.value.trainee) = $event)),
                  onChange: handleTraineeChange,
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "被辅导人区域" }, {
              default: _withCtx(() => [
                _createVNode(CustomerAreaCascader, {
                  appId: "cos_lbu",
                  value: dataForm.value.traineeRegion,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((dataForm.value.traineeRegion) = $event)),
                  disabled: true,
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, {
          title: "辅导信息",
          span: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: "客户名称",
              name: "cosId",
              rules: [{ required: true, message: '请选择' }]
            }, {
              default: _withCtx(() => [
                _createVNode(ClueAndCustomerSelect, {
                  appId: "cos_lbu",
                  value: dataForm.value.cosId,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((dataForm.value.cosId) = $event)),
                  label: dataForm.value.customerName,
                  "onUpdate:label": _cache[7] || (_cache[7] = ($event: any) => ((dataForm.value.customerName) = $event)),
                  view: __props.view,
                  onChange: handleCustomerNameChange
                }, null, 8, ["value", "label", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "跟进记录",
              name: "followId",
              rules: [{ required: true, message: '请选择' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: dataForm.value.followId,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((dataForm.value.followId) = $event)),
                  fieldNames: { label: 'startTime', value: 'id' },
                  options: followList.value,
                  allowClear: "",
                  placeholder: "请选择",
                  onChange: changeFollow,
                  onClick: handleFollowClick,
                  style: {"cursor":"pointer","color":"blue"},
                  view: __props.view
                }, null, 8, ["value", "options", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "跟进方式",
              name: "followMode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: selectedFollow.value.followMode,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((selectedFollow.value.followMode) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: true,
                  placeholder: "自动带出",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "联系人",
              name: "contactName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: selectedFollow.value.contactName,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((selectedFollow.value.contactName) = $event)),
                  valueModifiers: { trim: true },
                  maxlength: 200,
                  disabled: true,
                  placeholder: "自动带出",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              span: 12,
              label: "本阶段重点关注和提升的技能",
              name: "keyFocus",
              rules: [{ required: true, message: '请输入' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  maxlength: 2000,
                  placeholder: "请输入",
                  value: dataForm.value.keyFocus,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((dataForm.value.keyFocus) = $event)),
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              span: 12,
              label: "本次拜访的亮点和需要提升",
              name: "visitHlt",
              rules: [{ required: true, message: '请输入' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  maxlength: 2000,
                  placeholder: "请输入",
                  value: dataForm.value.visitHlt,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((dataForm.value.visitHlt) = $event)),
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              span: 12,
              label: "后续计划",
              name: "subPlans",
              rules: [{ required: true, message: '请输入' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  maxlength: 2000,
                  placeholder: "请输入",
                  value: dataForm.value.subPlans,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((dataForm.value.subPlans) = $event)),
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "附件上传",
              name: "fileId",
              span: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(UploadFile), {
                  value: dataForm.value.fileId,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((dataForm.value.fileId) = $event)),
                  valueType: "array",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "抄送人",
              name: "ccTo"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_UserSelect, {
                  permission: "",
                  value: dataForm.value.ccTo,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((dataForm.value.ccTo) = $event)),
                  mode: "multiple",
                  view: __props.view
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (props.type === 'review' || (dataForm.value.reviewTime !== undefined && dataForm.value.reviewTime !== null))
          ? (_openBlock(), _createBlock(_component_dc_layout_card, {
              key: 0,
              title: "回顾",
              span: 6
            }, {
              default: _withCtx(() => [
                _createVNode(_component_dc_form_item, {
                  label: "回顾时间",
                  name: "reviewTime",
                  rules: [{ required: true, message: '请输入' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(CosSingleDateTimePicker, {
                      defaultValue: "now",
                      startTime: dataForm.value.reviewTime,
                      "onUpdate:startTime": _cache[16] || (_cache[16] = ($event: any) => ((dataForm.value.reviewTime) = $event)),
                      disabled: true,
                      isRange: false,
                      view: (__props.view && props.type === 'comment') || props.type === 'view'
                    }, null, 8, ["startTime", "view"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }),
                _createVNode(_component_dc_form_item, {
                  span: 12,
                  label: "行动结果",
                  name: "actionResult",
                  rules: [{ required: true, message: '请输入' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosTextarea, {
                      maxlength: 2000,
                      placeholder: "请输入",
                      value: dataForm.value.actionResult,
                      "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((dataForm.value.actionResult) = $event)),
                      view: (__props.view && props.type === 'comment') || props.type === 'view'
                    }, null, 8, ["value", "view"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_dc_form_item, {
                  span: 12,
                  label: "执行结果",
                  name: "executionResult",
                  rules: [{ required: true, message: '请输入' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosTextarea, {
                      maxlength: 2000,
                      placeholder: "请输入",
                      value: dataForm.value.executionResult,
                      "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((dataForm.value.executionResult) = $event)),
                      view: (__props.view && props.type === 'comment') || props.type === 'view'
                    }, null, 8, ["value", "view"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_cos_footer_button, {
      value: dataForm.value,
      "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((dataForm).value = $event)),
      formRef: formRef.value
    }, {
      default: _withCtx(() => [
        (props.type === 'add' || props.type === 'edit' || props.type === 'review')
          ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              type: "primary",
              onClick: _cache[19] || (_cache[19] = ($event: any) => (handleSubmit())),
              loading: loading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }, 8, ["loading"])), [
              [_directive_permission, permissionPage.value.save]
            ])
          : _createCommentVNode("", true),
        (props.type === 'view' && dataForm.value.status !== 2)
          ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
              key: 1,
              type: "primary",
              onClick: editRow
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 编辑 ")
              ]),
              _: 1
            })), [
              [_directive_permission, 'lbu_sale_skills_coaching_edit_btn']
            ])
          : _createCommentVNode("", true),
        (props.type === 'view' && dataForm.value.status !== 2)
          ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
              key: 2,
              onClick: confirmRow
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 确认 ")
              ]),
              _: 1
            })), [
              [_directive_permission, 'lbu_sale_skills_coaching_confirm_btn']
            ])
          : _createCommentVNode("", true),
        (
        props.type === 'view' &&
        dataForm.value.status === 2 &&
        !dataForm.value.actionResult &&
        _unref(shareInfo).getUserInfo().work_code === dataForm.value.mentor
      )
          ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
              key: 3,
              onClick: reviewRow
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 回顾 ")
              ]),
              _: 1
            })), [
              [_directive_permission, 'lbu_sale_skills_coaching_review_btn']
            ])
          : _createCommentVNode("", true),
        (props.type === 'view' && dataForm.value.status === 2)
          ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
              key: 4,
              onClick: commentRow
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 评论 ")
              ]),
              _: 1
            })), [
              [_directive_permission, 'lbu_sale_skills_coaching_comment_btn']
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["value", "formRef"])
  ], 64))
}
}

})